interface Props {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  photoUrl?: string;
}

export default function PageHeader({ title, subtitle, actions, photoUrl }: Props) {
  return (
    <div
      className={`relative overflow-hidden ${
        photoUrl ? "min-h-[180px]" : "bg-forest-800"
      }`}
      style={
        photoUrl
          ? { backgroundImage: `url(${photoUrl})`, backgroundSize: "cover", backgroundPosition: "center" }
          : undefined
      }
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-hero-gradient" />

      {/* Content */}
      <div className="relative px-6 py-8 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-display font-bold text-white text-balance leading-tight pl-10 lg:pl-0">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-1 text-forest-200 text-sm">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
          )}
        </div>
      </div>
    </div>
  );
}
